import React, { FC } from 'react';

const ReferAFriend: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M406.08 175.194C406.08 134.394 372.88 101.094 331.98 101.094H161.38C120.58 101.094 87.2795 134.294 87.2795 175.194V332.494L406.08 335.294V175.194Z"
        fill="#EFF2F4"
      />
      <path
        d="M161.379 419.794H331.979C356.479 419.794 378.179 407.894 391.679 389.494H101.679C115.179 407.894 136.879 419.794 161.379 419.794Z"
        fill="#EFF2F4"
      />
      <path
        d="M406.08 335.194L87.2795 332.394V345.694C87.2795 362.094 92.5795 377.194 101.68 389.494H391.68C400.68 377.194 406.08 362.094 406.08 345.694V335.194Z"
        fill="#C1DAE5"
      />
      <path
        d="M296.18 306.494C299.079 302.494 304.579 299.594 311.479 298.294L300.68 261.394H162.679L148.979 309.694H294.479C294.879 308.494 295.48 307.494 296.18 306.494Z"
        fill="#F7C6CC"
      />
      <path
        d="M295.18 317.994H146.68L137.78 349.194H326.38L320.88 330.394C308.78 329.794 298.58 324.894 295.18 317.994Z"
        fill="#F7C6CC"
      />
      <path
        d="M154.079 261.394H120.879C120.779 261.394 120.779 261.394 120.679 261.394L97.5793 309.694H140.279L154.079 261.394Z"
        fill="#F7C6CC"
      />
      <path
        d="M137.979 317.994H93.6794L78.6794 349.194H129.079L137.979 317.994Z"
        fill="#F7C6CC"
      />
      <path
        d="M342.979 376.094H409.279C419.379 376.094 426.48 366.794 424.68 357.494H337.479L342.979 376.094Z"
        fill="#F7C6CC"
      />
      <path
        d="M75.2795 357.494C73.4795 366.794 80.5795 376.094 90.6795 376.094H121.479L126.779 357.494H75.2795Z"
        fill="#F7C6CC"
      />
      <path
        d="M375.28 253.094L368.08 237.994C365.48 232.594 359.98 229.094 353.98 229.094H300.08L307.08 253.094H375.28Z"
        fill="#F7C6CC"
      />
      <path
        d="M135.38 357.494L130.08 376.094H334.28L328.78 357.494H135.38Z"
        fill="#F7C6CC"
      />
      <path
        d="M298.28 253.094L291.28 229.094H171.98L165.08 253.094H298.28Z"
        fill="#F7C6CC"
      />
      <path
        d="M163.28 229.094H146.08C140.08 229.094 134.58 232.594 131.98 237.994L124.78 253.094H156.48L163.28 229.094Z"
        fill="#F7C6CC"
      />
      <path
        d="M346.979 321.494C343.779 325.894 337.379 328.994 329.479 330.094L335.079 349.294H421.279L406.379 317.994H348.779C348.379 319.194 347.779 320.394 346.979 321.494Z"
        fill="#F7C6CC"
      />
      <path
        d="M319.979 297.494C332.879 297.494 344.079 302.494 347.779 309.594H402.279L379.18 261.294H309.479L319.979 297.494Z"
        fill="#F7C6CC"
      />
      <path
        d="M334.28 376.094H342.98L337.58 357.494H424.78L421.38 349.194H335.18L329.48 329.994C337.38 328.894 343.78 325.894 346.98 321.394C347.78 320.294 348.38 319.094 348.68 317.894H406.28L402.28 309.594H347.78C343.98 302.394 332.78 297.494 319.98 297.494L309.48 261.394H379.28L375.28 253.094H306.98L299.98 229.094H291.28L298.28 253.094H165.08L171.88 229.094H163.18L156.38 253.094H124.58L120.58 261.394C120.68 261.394 120.68 261.394 120.78 261.394H153.98L140.28 309.694H97.5795L93.5795 317.994H137.98L129.08 349.194H78.6795L75.2795 357.494H126.78L121.48 376.094H130.18L135.48 357.494H328.88L334.28 376.094L335.78 381.394L334.28 376.094ZM341.48 313.994C341.68 314.694 341.78 315.694 340.88 316.994C339.08 319.394 333.88 322.394 325.08 322.794C312.98 323.294 303.08 318.494 301.68 313.894C301.48 313.194 301.38 312.194 302.28 310.894C304.08 308.494 309.28 305.494 318.08 305.094C318.68 305.094 319.28 305.094 319.88 305.094C331.18 305.094 340.18 309.594 341.48 313.994ZM162.78 261.394H300.78L311.58 298.294C304.68 299.594 299.18 302.494 296.28 306.494C295.58 307.494 294.98 308.594 294.68 309.694H149.08L162.78 261.394ZM137.78 349.194L146.68 317.994H295.18C298.58 324.894 308.78 329.794 320.88 330.394L326.38 349.194H137.78Z"
        fill="white"
      />
      <path
        d="M319.879 305.094C319.279 305.094 318.679 305.094 318.079 305.094C309.179 305.494 304.079 308.494 302.279 310.894C301.279 312.194 301.479 313.294 301.679 313.894C302.979 318.494 312.979 323.294 325.079 322.794C333.979 322.394 339.079 319.394 340.879 316.994C341.879 315.694 341.679 314.594 341.479 313.994C340.179 309.594 331.179 305.094 319.879 305.094Z"
        fill="#F7C6CC"
      />
      <path
        d="M338.38 172.693C338.38 118.593 291.48 75.3935 236.18 81.5935C194.88 86.1935 161.28 119.093 155.88 160.293C151.68 192.393 164.08 221.593 185.58 240.893H185.48L241.48 300.693C242.68 302.193 244.58 303.193 246.68 303.193C248.58 303.193 250.38 302.393 251.58 301.093L307.98 240.893H307.78C326.48 224.093 338.38 199.793 338.38 172.693Z"
        fill="#FF2B85"
      />
      <path
        d="M279.123 174.696C282.034 156.761 269.854 139.861 251.918 136.95C233.983 134.039 217.083 146.219 214.172 164.155C211.261 182.091 223.441 198.991 241.377 201.901C259.313 204.812 276.213 192.632 279.123 174.696Z"
        stroke="white"
        strokeWidth="15.2061"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ReferAFriend;
